"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcMessageHeaderT = exports.RpcMessageHeader = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const transaction_id_js_1 = require("../../solarxr-protocol/datatypes/transaction-id.js");
const rpc_message_js_1 = require("../../solarxr-protocol/rpc/rpc-message.js");
class RpcMessageHeader {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsRpcMessageHeader(bb, obj) {
        return (obj || new RpcMessageHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsRpcMessageHeader(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new RpcMessageHeader()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * For a request, this identifies the request. For a response, this corresponds
     * to the request that it is responding to.
     */
    txId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new transaction_id_js_1.TransactionId()).__init(this.bb_pos + offset, this.bb) : null;
    }
    messageType() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : rpc_message_js_1.RpcMessage.NONE;
    }
    message(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startRpcMessageHeader(builder) {
        builder.startObject(3);
    }
    static addTxId(builder, txIdOffset) {
        builder.addFieldStruct(0, txIdOffset, 0);
    }
    static addMessageType(builder, messageType) {
        builder.addFieldInt8(1, messageType, rpc_message_js_1.RpcMessage.NONE);
    }
    static addMessage(builder, messageOffset) {
        builder.addFieldOffset(2, messageOffset, 0);
    }
    static endRpcMessageHeader(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createRpcMessageHeader(builder, txIdOffset, messageType, messageOffset) {
        RpcMessageHeader.startRpcMessageHeader(builder);
        RpcMessageHeader.addTxId(builder, txIdOffset);
        RpcMessageHeader.addMessageType(builder, messageType);
        RpcMessageHeader.addMessage(builder, messageOffset);
        return RpcMessageHeader.endRpcMessageHeader(builder);
    }
    unpack() {
        return new RpcMessageHeaderT((this.txId() !== null ? this.txId().unpack() : null), this.messageType(), (() => {
            const temp = (0, rpc_message_js_1.unionToRpcMessage)(this.messageType(), this.message.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.txId = (this.txId() !== null ? this.txId().unpack() : null);
        _o.messageType = this.messageType();
        _o.message = (() => {
            const temp = (0, rpc_message_js_1.unionToRpcMessage)(this.messageType(), this.message.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.RpcMessageHeader = RpcMessageHeader;
class RpcMessageHeaderT {
    constructor(txId = null, messageType = rpc_message_js_1.RpcMessage.NONE, message = null) {
        this.txId = txId;
        this.messageType = messageType;
        this.message = message;
    }
    pack(builder) {
        const message = builder.createObjectOffset(this.message);
        return RpcMessageHeader.createRpcMessageHeader(builder, (this.txId !== null ? this.txId.pack(builder) : 0), this.messageType, message);
    }
}
exports.RpcMessageHeaderT = RpcMessageHeaderT;
